import request from '../utils/request.util'

export default {
  getList (params) {
    return request.get('/users', { params })
  },
  getOne (id) {
    return request.get(`/users/${id}`)
  },
  create (params) {
    return request.post('/users', params)
  },
  update (params) {
    return request.put(`/users/${params.id}`, params)
  },
  changePassword (params) {
    return request.post('/users/change-password', params)
  }
}
